import { useCurrentUser } from "@/hooks/user/useCurrentUser";
import GenericPlaceholder from "./GenericPlaceholder";
import { useNotePageContextSelector } from "../../../hooks/NotePageContext";
import EmojiPicker from "@/components/EmojiPicker";
import { ASSETS_URL } from "@/config/deployConstants";

const NoteTitleEmojiPicker = ({ sx }) => {
    const note = useNotePageContextSelector(state => state.note);
    const isNoteOwner = useNotePageContextSelector(state => state.isNoteOwner);

    const update = useNotePageContextSelector(state => state.update);

    const { userId } = useCurrentUser();
    const dontDisplayEmoji = !isNoteOwner && !note?.icon?.emoji;

    if (dontDisplayEmoji) {
        return null;
    }

    return (
        <div style={{ zIndex: 1000 }}>
            <EmojiPicker
                btnProps={{
                    title: "Change Emoji",
                    sx: {
                        padding: "0rem 1rem",
                        fontSize: "7.5rem",
                        "&&:hover": { boxShadow: "none" },
                        "&&:active": { boxShadow: "none" },
                        ...sx,
                    },
                }}
                onIconChange={update}
                icon={note?.icon}
                disabled={userId !== note?.userId}
                placeholder={
                    <GenericPlaceholder
                        text="Add Icon"
                        icon={`${ASSETS_URL}/images/laugh.png`}
                        imgAlt="emoji"
                        containerStyle={{ cursor: "pointer" }}
                    />
                }
            />
        </div>
    );
};

export default NoteTitleEmojiPicker;
